import { useAuth } from '../contexts/AuthContext';

export const useUser = () => {
  const { user, token } = useAuth();

  return {
    userId: user?.id,
    userEmail: user?.email,
    userName: user?.name,
    token,
    user
  };
};